"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _UserAdd = _interopRequireDefault(require("@react/react-spectrum/Icon/UserAdd"));

var _EmptyState = _interopRequireDefault(require("./EmptyState"));

var _svgs = require("../../lib/svgs");

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _CommentsEmptyState = _interopRequireDefault(require("./CommentsEmptyState.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Displays message that no comments exist
 * @param {Object} props - props for component
 * @returns {undefined}
 */
var CommentsEmptyState = function CommentsEmptyState(_ref) {
  var onShare = _ref.onShare;

  var _useContext = (0, _react.useContext)(_AppContext.default),
      reviewType = _useContext.reviewType,
      shareStatus = _useContext.shareStatus;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var onShareClick = (0, _react.useCallback)(function () {
    onShare();
  }, [onShare]);
  var title;
  var subtitle;
  var showShareButton = false;
  var illustratrion;
  var emptyStateTestId;

  if (shareStatus === 'unshared' && reviewType === 'cloudDoc') {
    illustratrion = _svgs.UnsharedIllustration;
    title = 'comments.empty-state.unshared.title';
    subtitle = 'comments.empty-state.unshared.subtitle';
    showShareButton = !!onShare;
    emptyStateTestId = 'empty-state-cloud-unshared';
  } else {
    illustratrion = /*#__PURE__*/_react.default.createElement(_svgs.CommentIllustration, {
      size: "L"
    });
    title = 'comments.empty-state.shared.title';
    subtitle = 'comments.empty-state.shared.subtitle';
    emptyStateTestId = 'empty-state';
  }

  return /*#__PURE__*/_react.default.createElement(_EmptyState.default, {
    testId: emptyStateTestId
  }, /*#__PURE__*/_react.default.createElement(_EmptyState.default.Illustration, null, illustratrion), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Title, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: title
  })), /*#__PURE__*/_react.default.createElement(_EmptyState.default.Subtitle, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: subtitle
  })), showShareButton && /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _CommentsEmptyState.default.commentsShareForReviewBtn,
    "data-testid": "comments-empty-state-cta",
    variant: "cta",
    onClick: onShareClick,
    icon: /*#__PURE__*/_react.default.createElement(_UserAdd.default, null),
    label: formatMessage({
      id: 'comments.empty-state.unshared.share'
    })
  }));
};

CommentsEmptyState.propTypes = {
  onShare: _propTypes.default.func
};
var _default = CommentsEmptyState;
exports.default = _default;